import React, { useState } from 'react';
import Modal from '../../Utilities/DraggableModal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import FuncFetch from '../../Utilities/funcFetch';
import { useMsal } from '@azure/msal-react';

const AddArbitrator = ({ show, onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const { instance, accounts } = useMsal();
    const [formData, setFormData] = useState({
        arbitratorName: '',
        arbitratorEmail: '',
        active: true
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);
        
        FuncFetch(
            `${process.env.REACT_APP_API_URL}/Admin/PostArbitrator`,
            formData,
            'POST',
            null,
            instance,
            accounts
        )
        .then((response) => {
            setLoading(false);
            setSuccess('Arbitrator added successfully!');
            setTimeout(() => {
                if (onSuccess) onSuccess();
                onClose();
            }, 1500);
        })
        .catch((error) => {
            console.error('Error adding arbitrator:', error);
            setLoading(false);
            setError('Failed to add arbitrator. Please try again.');
        });
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Arbitrator</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Arbitrator Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="arbitratorName"
                            value={formData.arbitratorName}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="arbitratorEmail"
                            value={formData.arbitratorEmail}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            name="active"
                            label="Active"
                            checked={formData.active}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    {loading && <Spinner animation="border" className="d-block mx-auto my-3" />}
                    {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
                    {success && <Alert variant="success" className="mt-3">{success}</Alert>}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? 'Adding...' : 'Add Arbitrator'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddArbitrator;